
import thMessages from '../locales/th_TH';

const ThLang = {
    messages: {
        ...thMessages,
    },
    locale: 'th-TH',
 
};
export default ThLang;
